import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ProfileLayout = lazy(() => import('@/pages/profile/layout'));

// Lazy load profile pages
const ProfilePage = lazy(() => import('@/pages/profile'));
const UpdateProfilePage = lazy(() => import('@/pages/profile/update'));
const ProfileCompanyPage = lazy(() => import('@/pages/profile/company'));
const ConfirmAccessPage = lazy(() => import('@/pages/profile/confirm-access'));
const ProfileClientsPage = lazy(() => import('@/pages/profile/clients'));
const ProfileClientLayout = lazy(() => import('@/pages/profile/clients/[clientId]/layout'));
const ProfileClientJobSpecsPage = lazy(() => import('@/pages/profile/clients/[clientId]/jobSpecifications'));
const ProfileCompanyContractsLayout = lazy(() => import('@/pages/profile/clients/[clientId]/companyContracts/layout'));
const ProfileCompanyContractsPage = lazy(() => import('@/pages/profile/clients/[clientId]/companyContracts'));
const ProfileCompanyContractLayout = lazy(
  () => import('@/pages/profile/clients/[clientId]/companyContracts/[companyContractId]/layout')
);
const ProfileCompanyContractJobSpecsPage = lazy(
  () => import('@/pages/profile/clients/[clientId]/companyContracts/[companyContractId]/jobSpecifications')
);
const ProfileHistoryPage = lazy(() => import('@/pages/profile/history'));
const ProfilePermissionsPage = lazy(() => import('@/pages/profile/permissions'));

/**
 * Profile routes
 * Handles user profile management
 */
export const profileRoutes: RouteConfig = {
  path: '/profile',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: ProfileLayout,
      element: ProfilePage,
    },
    {
      path: '/update',
      layout: ProfileLayout,
      element: UpdateProfilePage,
    },
    {
      path: '/company',
      layout: ProfileLayout,
      element: ProfileCompanyPage,
    },
    {
      path: '/confirm-access',
      layout: ProfileLayout,
      element: ConfirmAccessPage,
    },
    {
      path: '/history',
      layout: ProfileLayout,
      element: ProfileHistoryPage,
    },
    {
      path: '/permissions',
      layout: ProfileLayout,
      element: ProfilePermissionsPage,
    },
    {
      path: '/clients',
      layout: ProfileLayout,
      element: ProfileClientsPage,
    },
    {
      path: '/clients/:clientId',
      layout: ProfileLayout,
      children: [
        {
          path: '/companyContracts',
          layout: ProfileCompanyContractsLayout,
          children: [
            {
              path: '',
              element: ProfileCompanyContractsPage,
            },
            {
              path: '/:companyContractId',
              layout: ProfileCompanyContractLayout,
              children: [
                {
                  path: '/jobSpecifications',
                  element: ProfileCompanyContractJobSpecsPage,
                },
              ],
            },
          ],
        },
        {
          path: '/jobSpecifications',
          layout: ProfileClientLayout,
          element: ProfileClientJobSpecsPage,
        },
      ],
    },
  ],
};
